import React, { useEffect, useState } from "react";
import { ScopedStyles } from "./styled/GlobalStyles";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import StatsModern from "./components/Stats";
import OTC from "./components/OTC";
import Marketplace from "./components/Marketplace";
import LiveAuctions from "./components/LiveAuctions";
import PaymentsIBAN from "./components/PaymentsIBAN";
import TradingVoting from "./components/TradingVoting";
import News from "./components/News";
import SocialLinks from "./components/SocialLinks";
import CookieBanner from "./components/CookieBanner";
import {
  gettotalAccounts,
  gettotalBalance,
  getstoreDetails,
  getotcMarketplaceDetails,
} from "../../../utils/services/user.service";
import numeral from "numeral";

export default function NewHomePage() {
  const [statsData, setStatsData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [liveAuctionsCount, setLiveAuctionsCount] = useState(0);

  useEffect(() => {
    const scrollTo = window.location.hash
      ? window.location.hash.substring(1)
      : null;
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el)
        setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          50
        );
    }
  }, []);

  useEffect(() => {
    const fetchStatsData = async () => {
      setIsLoading(true);
      try {
        const [accountsRes, balanceRes, storeRes, marketplaceRes] =
          await Promise.all([
            gettotalAccounts(),
            gettotalBalance(),
            getstoreDetails(),
            getotcMarketplaceDetails(),
          ]);

        const newData = [
          {
            label: "Users",
            value: accountsRes?.data?.result?.totalUsers || 0,
            color: "#5ce9ff",
          },
          {
            label: "Total Volume",
            value: `$${numeral(balanceRes?.data?.result?.totalBalance || 0)
              .format("0a")
              .toUpperCase()}`,
            color: "#00f7d2",
          },
          {
            label: "Total Stores",
            value: storeRes?.data?.totalStore || 0,
            color: "#5ce9ff",
          },
          {
            label: "Live Auctions",
            value: liveAuctionsCount || 0,
            color: "#00f7d2",
          },
        ];

        setStatsData(newData);
      } catch (error) {
        console.error("Error fetching stats data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStatsData();
  }, [liveAuctionsCount]);

  useEffect(() => {
    try {
      const consent = localStorage.getItem("custodiy-cookie-consent");
      if (consent !== "accepted") {
        setShowCookieBanner(true);
      }
    } catch (error) {
      console.error("Unable to read cookie consent:", error);
      setShowCookieBanner(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    try {
      localStorage.setItem("custodiy-cookie-consent", "accepted");
    } catch (error) {
      console.error("Unable to persist cookie consent:", error);
    }
    setShowCookieBanner(false);
  };

  const handleDismissCookies = () => {
    setShowCookieBanner(false);
  };

  return (
    <ScopedStyles>
      <main>
        <Header />
        <Hero />
        <StatsModern statsData={statsData} />
        {/* <OTC /> */}
        <Marketplace />
        <LiveAuctions onAuctionCountChange={setLiveAuctionsCount} />
        {/* <PaymentsIBAN /> */}
        {/* <TradingVoting /> */}
        <News />
        <SocialLinks />
        <CookieBanner
          visible={showCookieBanner}
          onAccept={handleAcceptCookies}
          onDismiss={handleDismissCookies}
        />
        <Footer />
      </main>
    </ScopedStyles>
  );
}
